export const secondsToHours = (seconds: number, decimals = 1) => {
  const hours = seconds / 3600;
  return hours.toFixed(decimals);
};
